module.exports = __webpack_public_path__ + "img/image39.03e32efe.png";